import React from 'react';
import { UserProvider } from '../../context/user/UserContext';
import { EventsProvider } from '../../context/events/EventsContext';

const UserEventsProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <UserProvider>
      <EventsProvider>{children}</EventsProvider>
    </UserProvider>
  );
};

export default UserEventsProviders;
